<template>
  <div
    :class="$style.contextMenu"
    :style="{ left: mouseX + 'px', top: mouseY + 'px' }"
  >
    <div
      :class="$style.link"
      @click="confirm(0)"
    >
      {{ $t('common.confirmAll') }}
    </div>
    <div
      v-if="!isTargetChecked"
      :class="$style.link"
      @click="confirm(notificationId)"
    >
      {{ $t('common.confirmCurrent') }}
    </div>
    <router-link
      v-if="isTargetEvent"
      :class="$style.link"
      :to="{
        name: 'computers-computer-log-record',
        params: {
          computer: userId,
          log: log.slug,
          record: eventId,
        },
        query: {
          dateFrom: eventRange.day.from,
          dateTo: eventRange.day.to,
        },
      }"
      target="_blank"
    >
      {{ $t('common.goToHistoryEntry') }}
    </router-link>
    <router-link
      v-if="isTargetEvent"
      :class="$style.link"
      :to="{
        name: 'advanced',
        query: {
          dateFrom: eventRange.window.from,
          dateTo: eventRange.window.to,
          computer: userId,
          logId,
          record: eventId,
        },
      }"
      target="_blank"
    >
      {{ $t('common.viewInTheEventStream') }}
    </router-link>
  </div>
</template>

<script>
  import { checkRecord } from '@/api/methods/notifications';
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';

  dayjs.extend(utc);

  export default {
    props: [
      'notificationId',
      'userId',
      'mouseX',
      'mouseY',
      'eventId',
      'log',
      'isTargetChecked',
      'isTargetEvent',
      'targetTime',
      'isAllLogs',
    ],
    computed: {
      logId() {
        if (this.isAllLogs) return 'allLogs';
        return this.log.id;
      },
      eventRange() {
        const base = dayjs.utc(this.targetTime);

        return {
          day: {
            from: base.startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            to: base.endOf('day').format('YYYY-MM-DD HH:mm:ss'),
          },
          window: {
            from: base.subtract(10, 'minute').format('YYYY-MM-DD HH:mm:ss'),
            to: base.add(10, 'minute').format('YYYY-MM-DD HH:mm:ss'),
          },
        };
      },
    },
    methods: {
      async confirm(event) {
        await checkRecord(event);
        this.$emit('update');
      },
    },
  };
</script>

<style lang="scss" module>
  .contextMenu {
    box-shadow: 4px 6px 14px rgba(165, 165, 165, 0.4);
    position: absolute;
    background-color: white;
    width: 244px;
    z-index: 30;
    padding: 10px;
  }

  .link {
    text-decoration: none;
    display: block;
    padding: 3px;
    color: #4b4b4b;
    font-size: 14px;
    cursor: pointer;
    &:hover {
      background: $borderColor;
    }
  }
</style>
